import React, { useEffect, useState } from 'react'
import { useLocation } from 'react-router-dom';

import DigitalLetterInbox from './DigitalLetterInbox'
import DigitalLetterDetails from './DigitalLetterDetails'
import DigitalLetterComposeInbox from './DigitalLetterComposeInbox';

const STATUS = {
  COMPOSE: 'compose',
  DETAILS: 'details',
  INBOX: 'inbox'
};

export default function DigitalLetterInboxMain() {
    const location = useLocation();
    const [showInboxList, setShowInboxList] = useState(STATUS.INBOX)

    useEffect(() => {
      function updateShowInboxList() {
        const searchParams = new URLSearchParams(location.search);

        if (searchParams.get('edit') === 'true') {
          return setShowInboxList(STATUS.COMPOSE)
        } 

        if (searchParams.get('details') === 'true') {
          return setShowInboxList(STATUS.DETAILS)
        }

        return setShowInboxList(STATUS.INBOX);
      }
      
      updateShowInboxList();
    }, [location.search]);

    return (
      <>
        {showInboxList === STATUS.COMPOSE && <DigitalLetterComposeInbox/>}
        {showInboxList === STATUS.INBOX && <DigitalLetterInbox/>}
        {showInboxList === STATUS.DETAILS && <DigitalLetterDetails/>}
      </>
    );
}
